export default {
  volume: 'volumeSlim', 
  collar: 'collarColorado', 
  collarWhite: false, 
  sleeve: 'sleeveLong', 
  cuff: 'cuffOneButton', 
  cuffWhite: false, 
  fastening: 'fasteningStandard', 
  pocket: 'pocketNone', 
  pocketButton: false, 
  pocketFlap: false, 
  bottomCut: 'bottomCutStraight', 
  epaulettes: false, 
  patch: false, 
  backPleats: 'backPleatsNone', 
  collarHeight: 'collarHeight35mm', 
  collarBone: false,
  collarButtons: false,
  cuffStyle: 'cuffStyleRound',
  sleeveBottom: 'sleeveBottomPlank1Btn',
  collarDensity: false,
  cuffDensity: false,
  suspended: false,
  buttonsThread: 't0000',
  embroidery: 'embroideryNone',
  embroideryFont:  'Arial',
  embroideryColor: '1001M',
  embroideryVariant: 'embroideryLogo',
  embroideryEastern: 'easternDragon',
  embroideryZodiac1: 'zodiac1Scorpio',
  embroideryZodiac2: 'zodiac2Scorpio',
  embroideryLogo: 'logoMTM',
  embroideryRUSSIA: 'logoRussia',
  embroideryHearts: 'heart1',
  embroidery23Febr: '23febr_land',
  embroiderySmile: 'smile1',
  embroideryDifferent: 'differentAt',
  printProductNumber: false,  
  buttonThreadDecor: false,
  collarDecor: false,
  cuffDecor: false,
  buttons: 'SG2-1953',
  fabric: 'Sayama-white',
  collarFabric: 'Sayama-white',
  collarStandFabric: 'Sayama-white',
  collarStandFrontFabric: 'Sayama-white',
  sleeveFabric: 'Sayama-white',
  cuffFabric: 'Sayama-white', 
  cuffTurnFabric: 'Sayama-white',
  fasteningFabric: 'Sayama-white',
  fasteningThreadsFabric: 'Sayama-white',
  fasteningButtonsFabric: 'Sayama-white', 
  doubleCollarContrastFabric: 'Sayama-white', 
  threebleCollarContrastFabric: 'Sayama-white',
  pocketsFabric: 'Sayama-white', 
  epaulettesFabric: 'Sayama-white', 
  patchFabric: 'Sayama-white', 
  embroideryText: '',
  shirtRemarks: '',
  contrastFabric: 'Sayama-white',
  measurementsName: '',
}